var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHdc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9279 -8250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9279 8250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15710.363 7063.056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6482.166,1196.106q3.954,0,7.907,0a1.88,1.88,0,0,1,1.969,1.431,1.737,1.737,0,0,1,.05.456q.005,2.492,0,4.984a.736.736,0,0,1-.686.826.781.781,0,0,1-.885-.7,2.1,2.1,0,0,1-.014-.338q0-2.231,0-4.461c0-.494-.062-.556-.542-.556H6474.34c-.442,0-.519.074-.52.52,0,1.569,0,3.138,0,4.707a.789.789,0,0,1-1.2.731.733.733,0,0,1-.387-.688c0-1.7-.016-3.405,0-5.107a1.88,1.88,0,0,1,2.021-1.8Q6478.213,1196.1,6482.166,1196.106Z",
    transform: "translate(-32.799 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6432.577,1433.76c-.831,0-1.662,0-2.492,0a.719.719,0,0,1-.8-.872,2.484,2.484,0,0,1,2.535-2.371c.533,0,1.066,0,1.6,0a2.427,2.427,0,0,1,2.4,2.09c.013.091.042.18.054.271a.722.722,0,0,1-.767.881C6434.259,1433.764,6433.417,1433.76,6432.577,1433.76Z",
    transform: "translate(8 -219.979)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6449.643,1340.7a2.192,2.192,0,0,0,0,4.383,2.192,2.192,0,0,0,0-4.383Zm.006,3.576a1.385,1.385,0,1,1,1.385-1.384A1.385,1.385,0,0,1,6449.649,1344.275Z",
    transform: "translate(-9.074 -135.692)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6449.588,1340.548h.06a2.342,2.342,0,0,1,0,4.683h-.062a2.2,2.2,0,0,1-1.564-.667,2.4,2.4,0,0,1-.7-1.69A2.334,2.334,0,0,1,6449.588,1340.548Zm0,4.385h.053a2.042,2.042,0,0,0,0-4.083h-.051a2.031,2.031,0,0,0-1.967,2.028,2.1,2.1,0,0,0,.614,1.478A1.905,1.905,0,0,0,6449.586,1344.933Zm.063-3.577a1.535,1.535,0,1,1-1.534,1.535A1.537,1.537,0,0,1,6449.649,1341.356Zm0,2.769a1.235,1.235,0,1,0-1.234-1.234A1.236,1.236,0,0,0,6449.649,1344.125Z",
    transform: "translate(-9.074 -135.692)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6583.313,1433.76c-.831,0-1.661,0-2.491,0a.719.719,0,0,1-.805-.872,2.484,2.484,0,0,1,2.535-2.371c.533,0,1.067,0,1.6,0a2.427,2.427,0,0,1,2.4,2.09c.013.091.042.18.054.271a.722.722,0,0,1-.767.881C6584.994,1433.764,6584.154,1433.76,6583.313,1433.76Z",
    transform: "translate(-133.95 -219.979)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6584.821,1433.911h-4a.97.97,0,0,1-.738-.268.985.985,0,0,1-.216-.765,2.636,2.636,0,0,1,2.683-2.511h1l.6,0a2.585,2.585,0,0,1,2.545,2.218c.005.037.014.076.023.116a1.492,1.492,0,0,1,.031.159.942.942,0,0,1-.2.758.927.927,0,0,1-.715.291C6585.536,1433.91,6585.214,1433.911,6584.821,1433.911Zm-1.508-.3,1.508,0c.392,0,.713,0,1.013,0a.637.637,0,0,0,.492-.189.651.651,0,0,0,.127-.524,1.18,1.18,0,0,0-.025-.127c-.01-.045-.021-.091-.028-.14a2.286,2.286,0,0,0-2.25-1.962c-.352,0-.7,0-1.053,0h-.545a2.342,2.342,0,0,0-2.385,2.231.7.7,0,0,0,.137.54.688.688,0,0,0,.52.172q.866,0,1.734,0Z",
    transform: "translate(-133.95 -219.979)",
    fill: "#71aff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6600.378,1340.7a2.192,2.192,0,0,0,0,4.383,2.192,2.192,0,0,0,0-4.383Z",
    transform: "translate(-151.023 -135.692)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6600.323,1340.548h.06a2.342,2.342,0,0,1,0,4.683h-.062a2.2,2.2,0,0,1-1.564-.667,2.4,2.4,0,0,1-.7-1.69A2.334,2.334,0,0,1,6600.323,1340.548Zm0,4.385h.053a2.042,2.042,0,0,0,0-4.083h-.051a2.03,2.03,0,0,0-1.966,2.028,2.1,2.1,0,0,0,.614,1.478A1.905,1.905,0,0,0,6600.323,1344.933Z",
    transform: "translate(-151.023 -135.692)",
    fill: "#71aff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6727.425,1433.76c-.831,0-1.661,0-2.492,0a.72.72,0,0,1-.805-.872,2.485,2.485,0,0,1,2.535-2.371c.533,0,1.066,0,1.6,0a2.427,2.427,0,0,1,2.4,2.09c.013.091.042.18.054.271a.722.722,0,0,1-.768.881C6729.107,1433.764,6728.266,1433.76,6727.425,1433.76Z",
    transform: "translate(-269.275 -219.979)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6744.49,1340.7a2.192,2.192,0,0,0,0,4.383,2.192,2.192,0,0,0,0-4.383Zm.006,3.576a1.385,1.385,0,1,1,1.386-1.384A1.384,1.384,0,0,1,6744.5,1344.275Z",
    transform: "translate(-286.348 -135.692)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6744.435,1340.548h.06a2.342,2.342,0,0,1,0,4.683h-.062a2.2,2.2,0,0,1-1.564-.667,2.4,2.4,0,0,1-.7-1.69A2.334,2.334,0,0,1,6744.435,1340.548Zm0,4.385h.053a2.042,2.042,0,0,0,0-4.083h-.051a2.031,2.031,0,0,0-1.966,2.028,2.1,2.1,0,0,0,.614,1.478A1.905,1.905,0,0,0,6744.434,1344.933Zm.062-3.577a1.535,1.535,0,1,1-1.534,1.535A1.537,1.537,0,0,1,6744.5,1341.356Zm0,2.769a1.235,1.235,0,1,0-1.234-1.234A1.237,1.237,0,0,0,6744.5,1344.125Z",
    transform: "translate(-286.348 -135.692)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHdc);
export default __webpack_public_path__ + "static/media/icon-hdc.92c41464.svg";
export { ForwardRef as ReactComponent };